<template>
  <v-card flat height="100vh" :color="$store.state.corpInfo.darkTheme?'black':'#E2E6EF'"
    :class="[{'white--text':$store.state.corpInfo.darkTheme}, {'black--text':!$store.state.corpInfo.darkTheme}]" v-if="item">
    <div
      class="imgeSite"
      :style="item.img?styleWithImage:styleNoImage"
      style="cursor: pointer;"
    >
      <div class="imgShadow" 
        :style="{        
          background: `linear-gradient(
            to bottom,
            ${$store.state.corpInfo.darkTheme ? 
            '#00000000 0%, #000000 100%':'#ffffff00 0%, #E2E6EF 100%'}
          )`}"></div>
    </div>
    <div class="contInfo">
      <div class="backBtn">
        <v-btn icon x-large :dark="$store.state.corpInfo.darkTheme" @click="$root.goHome()">
          <v-icon large class="backBtnIcon">
            mdi-home
          </v-icon>
        </v-btn>
      </div>
      <div>
        <h1>{{ item.name[$root.getTextlang()] }}</h1>
        <h4>{{ $t("actions.categorias")[item.id_eventcata].title }}</h4>
      </div>
      <div v-if="item">
        <div class="DivAbout" :class="[{'open':aboutDroppedDown}]">
          <div v-if="item && item.acercade" v-html="item.acercade[$root.getTextlang()]" align="left"></div>
        </div>
        <div align="center" 
          v-if="item && item.acercade && item.acercade[$root.getTextlang()] && item.acercade[$root.getTextlang()].length > 0">
          <v-btn icon x-large :dark="$store.state.corpInfo.darkTheme" @click="toggleAbout()">
            <v-icon class="btnArrow" v-if="aboutDroppedDown">
              mdi-arrow-up
            </v-icon>
            <v-icon class="btnArrow" v-if="!aboutDroppedDown">
              mdi-arrow-down
            </v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <div v-show="showEventContent" class="mt-n8">
      <div v-if="(vEntorno && vEntorno.events[0].event_config === 4 && vEntorno.events[0].categories && vEntorno.events[0].categories.length !== 0) 
        || (vEntorno.events[0].event_config === 5)">
        <v-container v-if="!$store.state.sites.events[0].avialableDates" class="table-tickets-image">
          <v-row>
            <v-col md="4" cols="12">
              <v-skeleton-loader 
                dark
                min-height="400px"
                type="date-picker">
              </v-skeleton-loader>
            </v-col>
            <v-col md="8" cols="12">
              <v-skeleton-loader   
                v-for="i in 3"  
                :key="i"  
                class="mb-2"        
                max-height="160px"
                dark
                type="article">
              </v-skeleton-loader>
            </v-col> 
          </v-row>
        </v-container>
        <v-container v-if="$store.state.sites.events[0].avialableDates && loadingTicketsCategory && showTickets"  
        class="table-tickets-image">
          <v-row>
            <v-col md="4" cols="12">
              <v-skeleton-loader
                :dark="$store.state.corpInfo.darkTheme"
                min-height="400px"
                type="date-picker">
              </v-skeleton-loader>
            </v-col>
            <v-col md="8" cols="12">
              <v-skeleton-loader   
                :dark="$store.state.corpInfo.darkTheme"
                v-for="i in 3"  
                :key="i"  
                class="mb-2"        
                max-height="160px"
                type="article">
              </v-skeleton-loader>
            </v-col> 
          </v-row>
        </v-container>
        <div v-if="$store.state.sites.events[0].avialableDates">
          <DateList 
              v-if="$store.state.sites.events[0].avialableDates"
              v-show="!showTickets" 
              :resetDates="vEntorno.dialogDates"
              @displayTickets="displayTickets" 
              @loadCategories="loadingCategories"/>  
          <TableTicketsComplex 
            v-if="tickets && !loadingData" 
            @hideTickets="hideTickets"
            :loadingTicketsCategory="loadingTicketsCategory"
            :tickets="tickets" 
            :event="event" />
        </div>
      </div>
      <div v-if="vEntorno.events[0].event_config === 4 && vEntorno.events[0].categories.length === 0" class="mx-auto my-5 text-center grey--text">
        {{ $t('messages.noTickets') }}
      </div>
    </div>
  </v-card>
 </template>
 
<script>
import DateList from '../Events/DateList.vue';
import TableTicketsComplex from '../Events/TableTicketsComplex.vue';
import { mapActions } from 'vuex';
 
 export default {
  name: "limitedEntryEvent",
  props: ["item", "loadingData", "loadingTicketsCategory"],
  components: {
   DateList,
   TableTicketsComplex
  },
  data() {
    return {
      tab: 0,
      tabs: [],
      vEntorno: null,
      aboutDroppedDown: false,
      showEventContent: true,
      tickets : null,
      showTickets : true,
      loadA: false,
      tickets: null,
      event: null,
      styleWithImage: { 
        backgroundImage: 'url(' + this.$root.pathevens + this.item.img + ')', 
        height: this.aboutDroppedDown ? '100vh' : '300px' 
      },
      styleNoImage: {
        height: this.aboutDroppedDown ? '100vh' : '300px'
      }
    };
  },
  beforeMount() {
    this.resetEventValues()
    this.resetSells()
    this.begin()
  },
  methods: {
    ...mapActions({
      resetEventValues: 'sites/resetEventValues',
      resetSells: 'shopping/resetRegularSell'
    }),
    begin() {
      this.vEntorno = this.$store.state.sites;
      this.showTickets = false;
    },
    toggleAbout() {
      if (this.aboutDroppedDown == false) {
        this.aboutDroppedDown = true;
        this.showEventContent = false;
      } else {
        this.aboutDroppedDown = false;
        setTimeout(() => {
          this.showEventContent = true;
        }, 500);
      }
    },
    displayTickets(item) {
      this.tickets = false
      if (this.vEntorno.events[0].event_config !== 4) {
        this.$router.push({
          name: 'events',
          query: { 
            e: item.id_event, 
            ee: item.id_eventd
          }
        });
      } else {
        this.tickets = this.vEntorno.events[0].categories[0].ticketsGroups[0];
        this.event = item;
        this.showTickets = true;
      }
      return this.tickets
    },
    hideTickets() {
      this.showTickets = false;
      this.tickets = null
      this.event = null;
    },
    loadingCategories(event) {
      this.$emit("loadingCategories", event);
    }
  },
};
 </script>
 
 <style scoped>
 .table-tickets-image {
  max-width: 1300px;
  margin: 0px auto;
 }
 .Mytab {
  font-size: 12px;
  display: flex;
  max-width: 1300px;
  width: 100%;
  border-bottom: 2px solid #252525;
 }
 .Mytab .tab {
  padding: 8px 10px;
  border-radius: 5px 5px 0px 0px;
  font-weight: bold;
  letter-spacing: 2px;
 }
 .Mytab .tab:hover:not(.active){
  background: rgb(73, 69, 69);
  color: black;
  cursor: pointer;
 }
 .Mytab .active {
  background: #252525;
 }
 .skeleton-container {
  max-width: 1300px;
 }
 .DivCategory {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  max-width: 1000px;
 }
 .DivTable {
  display: flex;
  justify-content: space-evenly;
 }
 .btnArrow {
  font-size: 50px;
 }
 .imgShadow {
  width: 100%;
  height: 100%;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#000000', GradientType=0 );
 }
 .imgeSite {
  background-size: cover;
  background-position: 15% 15%;
  background-blend-mode: multiply;
  background-color: #626060;
  /* height: 300px; */
 }
 .contInfo {
  padding: 40px 40px 0px 40px;
  position: absolute;
  top: 10px;
  width: 100%;
 }
 .DivAbout {
  padding-top: 20px;
  height: 100px;
  overflow: hidden;
  transition: height 0.5s, transform 0.5s;
 }
 .open {
  height: calc(100vh - 200px) !important;
  overflow: auto !important;
 }
 .backBtn {
  display: flex;
  flex-direction: row;
  width: fit-content;
  position: absolute;
  top: 35px;
  left: calc(100% - 200px);
 }
 b {
  font-size: 1.5vw !important;
  padding-right: 0.5rem !important;
 }
 .animation {
  position: absolute;
  top: calc(50%);
  right: calc(50%);
 }
 
 @media (max-width: 1301px) {
  .Mytab {
    margin-left: 30px !important;
    margin-right: 30px !important;
    width: auto;
  }
 
  .skeleton-container {
    margin-left: 30px !important;
    margin-right: 30px !important;
    width: auto;
  }
 }
 
 @media (max-width: 959px) {
  .table-tickets-image {
    max-width: 500px;
    margin: 0px auto;
  }
 }
 
 @media only screen and (max-width: 700px) {
  .btnArrow {
    font-size: 30px;
  }
  .contInfo {
    padding: 20px 20px 0px 20px;
  }
  h1 {
    font-size: 20px;
  }
  h4 {
    font-size: 12px;
  }
  .backBtn {
    top: 13px;
    /* left: calc(100% - 76px); */
    left: calc(100% - 70px);
  }
  .animation {
    top: calc(35%);
    right: calc(50%);
  }
  
  .Mytab {
    display: flex;
    flex-direction: column;
    margin-left: 15px !important;
    margin-right: 15px !important;
    border-bottom: 0px;
    border-left: 2px solid #252525;
  }
  
  .Mytab .tab {
    border-radius: 0px 5px 5px 0px;
  }
 
 /*  .imgeSite {
     height: 220px;
   } */
 }
 </style>